import { useIntl } from 'react-intl';

import StatusBadge from 'src/componentes/StatusBadge';
import {
  getLookupId,
  SITUACAO_APLICACAO_FORMULARIO_GLOBAL,
} from 'src/paginas/avaliacao-desempenho/PesquisaClima/utils';

const situacoes = {
  [SITUACAO_APLICACAO_FORMULARIO_GLOBAL.PREVISTA]: {
    labelId: 'labelAplicacaoPrevista',
    backgroundColor: '#EDE9FE',
    textColor: '#4C1D95',
  },
  [SITUACAO_APLICACAO_FORMULARIO_GLOBAL.VIGENTE]: {
    labelId: 'labelAplicacaoVigente',
    backgroundColor: '#E0F2FE',
    textColor: '#0C4A6E',
  },
  [SITUACAO_APLICACAO_FORMULARIO_GLOBAL.ENCERRADA]: {
    labelId: 'labelAplicacaoEncerrada',
    backgroundColor: '#ECFCCB',
    textColor: '#3F6212',
  },
};

function AplicacaoStatusBadge({ situacao, className }) {
  const intl = useIntl();
  const config = situacoes[getLookupId(situacao)];

  if (!config) return null;

  return (
    <StatusBadge
      className={className}
      text={intl.formatMessage({ id: config.labelId })}
      backgroundColor={config.backgroundColor}
      textColor={config.textColor}
    />
  );
}

export default AplicacaoStatusBadge;
